<template>
  <BasePopup
    v-model="isOpen"
    max-width="560px"
    variant="light"
    with-close
    @update:model-value="handlePopupVisibilityChange"
  >
    <template #title>
      <BaseTypography
        type="subtitle"
        weight="700"
        color="var(--color-foreground-main)"
        text-align="center"
        width="100%"
      >
        {{ t('КНОПКА') }}
      </BaseTypography>
    </template>
    <template #body>
      <div class="landing-button-type-popup">
        <BaseButton
          variant="primary"
          with-full
          with-decor
          rounded
          @click="handleSelectModule"
        >
          {{ t('Выбор модуля') }}
        </BaseButton>
        <BaseButton
          variant="primary"
          with-full
          with-decor
          rounded
          @click="handleSelectObject"
        >
          {{ t('Выбор объекта в модуле') }}
        </BaseButton>
      </div>
    </template>
  </BasePopup>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { BaseButton, BasePopup, BaseTypography } from '~/shared/ui'
import i18n from './LandingButtonTypePopup.i18n.json'

const props = defineProps<{
  modelValue: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'selectModule'): void
  (e: 'selectObject'): void
}>()

const { t } = useI18n(i18n)

const isOpen = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
})

function handleSelectModule() {
  emit('selectModule')
  isOpen.value = false
}

function handleSelectObject() {
  emit('selectObject')
  isOpen.value = false
}

function handlePopupVisibilityChange(value: boolean) {
  if (!value) {
    emit('update:modelValue', false)
  }
}
</script>

<style lang="scss" scoped>
.landing-button-type-popup {
  display: flex;
  flex-direction: column;
  gap: rem(16px);
}
</style>
